import React from 'react'
import { Table } from 'antd';
import styles from './style/customizeTable.module.less';

class CustomizeTable extends React.Component {
    render() {
        return (
            <div className={styles.tableDiv}>
                <Table {...this.props} pagination={false} />
            </div>
        );
    }
}

export default CustomizeTable